import React, { useState, useEffect } from "react";
import axios from "axios";

const Prefooterads = () => {
  const [fetchedData1, setFetchedData1] = useState([]);
  const [fetchedData2, setFetchedData2] = useState([]);
  const [fetchedData3, setFetchedData3] = useState([]);

  // Inline CSS styles
  const containerStyle = {
    marginTop: "20px",
  };

  const imageCardStyle = {
    position: "relative",
    overflow: "hidden",
    borderRadius: "8px",
    marginBottom: "20px",
  };

  const imgStyle = {
    width: "100%",
    height: "200px",
    transition: "transform 0.3s ease",
  };

  //   const overlayStyle = {
  //     position: "absolute",
  //     bottom: "10px",
  //     left: "10px",
  //     color: "white",
  //     backgroundColor: "rgba(0, 0, 0, 0.6)",
  //     padding: "10px",
  //     borderRadius: "5px",
  //   };

  //   const headingStyle = {
  //     margin: "0 0 5px",
  //   };

  //   const buttonStyle = {
  //     backgroundColor: "#007bff",
  //     border: "none",
  //     padding: "8px 12px",
  //     color: "white",
  //     borderRadius: "4px",
  //     cursor: "pointer",
  //   };

  // Helper function for hover effect
  const handleMouseEnter = (e) => {
    e.target.style.transform = "scale(1.1)";
  };

  const handleMouseLeave = (e) => {
    e.target.style.transform = "scale(1)";
  };

  const fetchdata1 = async () => {
    try {
      const response1 = await axios.get(
        "https://api.dremerz.net/api/Kalanjiyam_Advertisement_Prefooterad1"
      );
      console.log(response1.data, "response.data");
      setFetchedData1(response1.data);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchdata2 = async () => {
    try {
      const response2 = await axios.get(
        "https://api.dremerz.net/api/Kalanjiyam_Advertisement_Prefooterad2"
      );
      console.log(response2.data, "response.data");
      setFetchedData2(response2.data);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchdata3 = async () => {
    try {
      const response3 = await axios.get(
        "https://api.dremerz.net/api/Kalanjiyam_Advertisement_Prefooterad3"
      );
      console.log(response3.data, "response.data");
      setFetchedData3(response3.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchdata1();
    fetchdata2();
    fetchdata3();
  }, []);

  return (
    <div>
      {/* New container with 2 cards per row */}
      <div className="container" style={containerStyle}>
        <div className="row">
          {/* Card 1 */}
          {fetchedData1?.map((item) => (
            <>
              <div className="col-md-4">
                <div className="image-card" style={imageCardStyle}>
                  <img
                    src={`https://api.dremerz.net/uploads/${item.banneradimage}`}
                    alt="Spring Collection"
                    style={imgStyle}
                    onMouseOver={handleMouseEnter}
                    onMouseOut={handleMouseLeave}
                    onFocus={handleMouseEnter}
                    onBlur={handleMouseLeave}
                  />
                </div>
              </div>
            </>
          ))}

          {/* Card 2 */}
          {/* {fetchedData2?.map((item) => (
            <>
              <div className="col-md-4">
                <div className="image-card" style={imageCardStyle}>
                  <img
                    src={`https://api.dremerz.net/uploads/${item.banneradimage}`}
                    alt="Exclusive Offers"
                    style={imgStyle}
                    onMouseOver={handleMouseEnter}
                    onMouseOut={handleMouseLeave}
                    onFocus={handleMouseEnter}
                    onBlur={handleMouseLeave}
                  />
                </div>
              </div>
            </>
          ))} */}

          {/* Card 3 */}
          {/* {fetchedData3?.map((item) => (
            <>
              <div className="col-md-4">
                <div className="image-card" style={imageCardStyle}>
                  <img
                    src={`https://api.dremerz.net/uploads/${item.banneradimage}`}
                    alt="Exclusive Offers"
                    style={imgStyle}
                    onMouseOver={handleMouseEnter}
                    onMouseOut={handleMouseLeave}
                    onFocus={handleMouseEnter}
                    onBlur={handleMouseLeave}
                  />
                </div>
              </div>
            </>
          ))} */}
        </div>
      </div>
    </div>
  );
};

export default Prefooterads;
